export default {"src":"/_next/static/media/arrow-dropdown.05e5caff.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};